import React from "react";
import { StyledButton, StyledHCard, StyledService } from "../components/Styles";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";
import Consultation from "../components/Consultation";

// Images
import img15 from "../components/Styles/assets/img15.webp";
import Acc from "../components/Styles/assets/Graphics/Acc.webp";
import RealTime from "../components/Styles/assets/Graphics/RealTime.webp";
import CostEffective from "../components/Styles/assets/Graphics/CostEffective.webp";
import Scalability from "../components/Styles/assets/Graphics/Scalability.webp";
import Security from "../components/Styles/assets/Graphics/Security.webp";
import Operations from "../components/Styles/assets/Graphics/Operations.webp";

function WebApplication() {
  const { t, i18n } = useTranslation();

  // Map advantages with icons
  const advantages = [
    { key: "accessibility", icon: Acc },
    { key: "realtime", icon: RealTime },
    { key: "cost", icon: CostEffective },
    { key: "scalability", icon: Scalability },
    { key: "security", icon: Security },
    { key: "operations", icon: Operations },
  ];

  return (
    <StyledService.Container>
      {/* ================= HERO ================= */}
      <StyledService.Hero>
        <StyledService.Content>
          <StyledService.Title lang={i18n.language}>
            {t("webApplication.title")}
          </StyledService.Title>

          <StyledService.Description>
            {t("webApplication.description")}
          </StyledService.Description>

          <Link to={`/${i18n.language}/${slugs.contact[i18n.language]}`}>
            <StyledButton.Main>
              {t("webApplication.cta")}
            </StyledButton.Main>
          </Link>
        </StyledService.Content>

        <StyledService.ImageContainer>
          <img
            src={img15}
            alt={t("webApplication.title")}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "10px",
            }}
          />
        </StyledService.ImageContainer>
      </StyledService.Hero>

      <Consultation />

      {/* ================= ADVANTAGES ================= */}
      <StyledService.H3 lang={i18n.language}>
        {t("webApplication.advantagesTitle")}
      </StyledService.H3>

      <StyledHCard.Container>
        {advantages.map(({ key, icon }) => (
          <StyledHCard.SingleCard key={key}>
            <StyledHCard.IconContainer>
              <img src={icon} alt={key} />
            </StyledHCard.IconContainer>

            <StyledHCard.Content>
              <StyledHCard.Title>
                {t(`webApplication.advantages.${key}.title`)}
              </StyledHCard.Title>

              <StyledHCard.Description>
                {t(`webApplication.advantages.${key}.desc`)}
              </StyledHCard.Description>
            </StyledHCard.Content>
          </StyledHCard.SingleCard>
        ))}
      </StyledHCard.Container>

      <Consultation />
    </StyledService.Container>
  );
}

export default WebApplication;